var moment = require('moment');
var module = angular.module('octopusApp.tasks');

module.factory('taskStatusRenderer', taskStatusRenderer);

function taskStatusRenderer(octoUtil, momentFromFilter) {
    function inspector(task) {
        var pendingInterruptions = task.HasPendingInterruptions;
        var warningsOrErrors = task.HasWarningsOrErrors;
        var duration = task.Duration;
        var errorMessage = task.ErrorMessage;
        var stateClass = task.State;
        var description = task.State;
        var previous = task.IsPrevious;
        var archive = !task.IsCurrent && !task.IsPrevious;
        var tip = "";
        var html = "";

        if (pendingInterruptions && !task.IsCompleted) {
            html = "<i class='fa fa-eye'></i>";
            description = "Waiting...";
            stateClass = "Paused";
            tip = "This task is waiting for manual intervention. Duration: " + duration;
        } else if (task.State === "Cancelling") {
            html = "<i class='fa fa-user-times'></i>";
            description = "Cancelling";
            tip = "Cancellation has been requested, attempting to stop the task.";
        } else if (task.State === "Queued") {
            html = "<i class='fa fa-clock-o'></i>";
            description = "Queued...";
            tip = (moment().isAfter(task.QueueTime) ? "This task was queued " : "This task has been scheduled to run ") + moment(task.QueueTime).fromNow();
        } else if (task.State === "Executing") {
            html = "<i class='fa fa-spinner fa-spin'></i>";
            tip = "This task is being executed by the Octopus Server. Duration: " + duration;
        } else if (task.State === "Failed") {
            html = "<i class='fa fa-exclamation-triangle'></i>";
            tip = "An error occurred whilst processing this task";
            if (errorMessage && errorMessage.length > 0) {
                tip = tip + ": " + errorMessage;
            } else {
                tip = tip + ". See the task details for more information.";
            }
        } else if (task.State === "Canceled") {
            html = "<i class='fa fa-user-times'></i>";
            tip = "This task was canceled by a user.";
        } else if (task.State === "TimedOut") {
            html = "<i class='fa fa-clock-o'></i>";
            description = "Timed out";
            var queueTime = moment(task.QueueTime).calendar();
            var expiryTime =  momentFromFilter(task.QueueTimeExpiry, task.QueueTime);
            var lastUpdated = moment(task.LastUpdatedTime).calendar();
            tip = "The task was scheduled to run " + queueTime + " within " + expiryTime + " but the Octopus Server attempted to run the task " + lastUpdated + ". This can happen when the Octopus server is too busy to process the task.";
        } else if (task.State === "Success") {
            if (warningsOrErrors) {
                html = "<i class='fa fa-check'></i><span class='status-overlay'><i class='fa fa-exclamation-triangle'></i></span>";
                stateClass = "SuccessWithWarnings";
                tip = "This task completed successfully, but warnings or errors were reported in the log. Duration: " + duration;
            } else {
                html = "<i class='fa fa-check'></i>";
                tip = "This task completed without any problems. Duration: " + duration;
            }
        }

        return {
            tip: tip,
            html: html,
            stateClass: stateClass,
            description: description,
            previous: previous,
            archive: archive
        };
    }

    function renderer(html, task) {
        var info = inspector(task);
        html.push("<span class='status ");
        html.push(octoUtil.escapeHtml(info.stateClass));
        if (info.previous) {
          html.push(" status-previous");
        }
        else if (info.archive) {
          html.push(" status-archive");
        }
        html.push("' data-tip='");
        html.push(octoUtil.escapeHtml(info.tip));
        html.push("'>");
        html.push(info.html);
        html.push("</span>");
    }

    function updater(task, domElement, previous, archive) {
        var info = inspector(task);

        domElement.removeClass();
        domElement.addClass("status");
        domElement.addClass(info.stateClass);
        if (previous) {
            domElement.addClass("status-previous");
        }
        if (archive) {
            domElement.addClass("status-archive");
        }
        domElement.attr("data-tip", info.tip);

        domElement.html(info.html);

        domElement.popover("destroy");
        domElement.popover({
            title: info.description,
            content: info.tip,
            trigger: 'hover',
            placement: "bottom",
            container: '#dynamicallyGeneratedContent'
        });
    }

    function bindPopovers(domElements) {
        domElements.each(function () {
            var domElement = $(this);
            domElement.popover({
                title: domElement.text(),
                content: domElement.data("tip"),
                trigger: 'hover',
                placement: "bottom",
                container: '#dynamicallyGeneratedContent'
            });
        });
    }

    return {
        inspect: inspector,
        render: renderer,
        update: updater,
        bindPopovers: bindPopovers
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/directives/task_status_renderer.js
// module id = 7594926643671476
// module chunks = 1